import { render, staticRenderFns } from "./ancillaryFacility.vue?vue&type=template&id=5a282dcd&scoped=true&"
import script from "./ancillaryFacility.vue?vue&type=script&lang=js&"
export * from "./ancillaryFacility.vue?vue&type=script&lang=js&"
import style0 from "./ancillaryFacility.vue?vue&type=style&index=0&id=5a282dcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a282dcd",
  null
  
)

export default component.exports